import React, { forwardRef } from "react";
import classNames from "classnames";
import "./Input.scss";

const Input = forwardRef(
    (
        {
            type = "text",
            value,
            onChange,
            placeholder,

            disabled = false,
            readOnly = false,
            required = false,

            error = "",
            helper = "",

            leftIcon,
            rightIcon,

            className = "",

            onFocus,
            onBlur,
            onKeyDown,

            ...rest
        },
        ref
    ) => {
        return (
            <div
                className={classNames(
                    "input",
                    {
                        "input--error": error,
                        "input--disabled": disabled,
                    },
                    className
                )}
            >
                <div className="input__wrapper">
                    {leftIcon && (
                        <div className="input__icon input__icon--left">
                            {leftIcon}
                        </div>
                    )}

                    <input
                        ref={ref}
                        type={type}
                        value={value}
                        onChange={onChange}
                        placeholder=" "
                        disabled={disabled}
                        readOnly={readOnly}
                        required={required}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        onKeyDown={onKeyDown}
                        className="input__field"
                        {...rest}
                    />

                    <label className="input__label">
                        {placeholder}
                    </label>

                    {rightIcon && (
                        <div className="input__icon input__icon--right">
                            {rightIcon}
                        </div>
                    )}
                </div>

                {(error || helper) && (
                    <span className="input__message">
                        {error || helper}
                    </span>
                )}
            </div>
        );
    }
);

Input.displayName = "Input";

export default Input;